import React from "react";
import { GridRenderCellParams } from "@mui/x-data-grid";

import { BillingStatus } from "../../types/billings";
import { BillingStatusTag } from "../BillingStatusTag";

interface ITableTagCellProps {
  params: GridRenderCellParams<string>;
}

export const TableBillingStatusTagCell: React.FC<ITableTagCellProps> = ({ params }) => {
  return <BillingStatusTag value={params.value as BillingStatus} />;
};
